import { Link, useLocation } from "@tanstack/react-router";
import { BookOpen, GraduationCap, Mail, SlidersHorizontal, Users } from "lucide-react";
import { cn } from "@/lib/utils";

const settingsTabs = [
  { label: "Users", href: "/dashboard/settings/users", icon: Users },
  { label: "Courses", href: "/dashboard/settings/courses", icon: BookOpen },
  { label: "Training", href: "/dashboard/settings/training", icon: GraduationCap },
  { label: "System", href: "/dashboard/settings/system", icon: SlidersHorizontal },
  { label: "Email", href: "/dashboard/settings/email", icon: Mail },
];

export function SettingsLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  return (
    <>
      {/* Settings header */}
      <div className="mb-8">
        <h1
          style={{
            fontFamily: "'Raleway', sans-serif",
            fontWeight: 800,
            color: "#0f1944",
            fontSize: 24,
            margin: 0,
          }}
        >
          Settings
        </h1>
        <p style={{ fontSize: 13, color: "#608099", marginTop: 6, marginBottom: 0 }}>
          Manage your workspace configuration.
        </p>
      </div>

      {/* Tab navigation */}
      <div className="relative mb-8">
        <div className="-mx-4 px-4 overflow-x-auto md:mx-0 md:px-0 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <nav className="flex gap-1 whitespace-nowrap">
            {settingsTabs.map((tab) => {
              const isActive = location.pathname === tab.href;

              return (
                <Link
                  key={tab.href}
                  to={tab.href}
                  role="tab"
                  aria-selected={isActive}
                  className={cn(
                    "group relative flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-colors rounded-md",
                    isActive
                      ? "bg-primary/10 text-primary"
                      : "text-muted-foreground hover:bg-muted hover:text-foreground",
                  )}
                >
                  <tab.icon className="h-4 w-4 shrink-0" />
                  <span>{tab.label}</span>
                </Link>
              );
            })}
          </nav>
        </div>

        {/* Baseline border */}
        <div className="absolute bottom-0 left-0 right-0 h-px bg-border" />
      </div>

      {/* Tab content */}
      {children}
    </>
  );
}
